import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { userRolesDefaultValues } from './model';
import { userRoleFormSchema } from './schemas';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(userRoleFormSchema),
    defaultValues: userRolesDefaultValues,
  });
}
